"use client";

import React, { forwardRef } from "react";
import Image from "next/image";
import { useTranslations } from "i18n";
import { handleContentfulLoader } from "utils/images/contentfulLoader";

type CTAProps = React.HTMLAttributes<HTMLElement>;
const DownloadAppCTA = forwardRef<HTMLDivElement>((props: CTAProps, ref) => {
  const t = useTranslations("homepage");
  // aria-controls prop causing hydration mismatch with generated radix id
  const { "aria-controls": ariaControls, ...rest } = props;

  return (
    <div
      ref={ref}
      role="button"
      className="relative flex w-full max-w-[240px] cursor-pointer items-center justify-between rounded bg-white px-4 py-[9.5px]"
      {...rest}
    >
      <Image
        priority
        src="https://cdn.builder.io/api/v1/image/assets%2F1b77ce3a269a43e985e77f3d65f715ba%2F8c8f53eeeb9e4540969ccba229bb3235?quality=100"
        alt="qr"
        height={65}
        width={65}
        loader={handleContentfulLoader}
      />
      <span className="ml-4 text-left text-sm leading-4 font-semibold text-black">
        {t("heroDownloadText")}
      </span>
    </div>
  );
});

export default DownloadAppCTA;
